import { push } from 'connected-react-router'
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from 'helpers/api/ApiCalls';

/**
 * Register user from Registration form submission.
 */
function* submitUserSettingsFormSaga({ payload }) {
    try {
        let img_type = undefined;
        let img_data = payload["profile-photo"] ? (payload["profile-photo"]).replace(/^data:image\/[a-z]+;base64,/, "") : undefined;
        if (payload["profile-photo"] && payload["profile-photo"].includes("image/jpeg")) {
          img_type = "jpg";
        }
        if (payload["profile-photo"] && payload["profile-photo"].includes("image/png")) {
          img_type = "png";
        }
        if (payload["profile-photo"] && payload["profile-photo"].includes("image/gif")) {
          img_type = "gif";
        }
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.SUBMIT_USER_SETTINGS_FORM,
            data: {
                id: payload.id,
                email: payload.email,
                firstname: payload.firstname,
                lastname: payload.lastname,
                image_data: img_data,
                image_type: img_type,
                phone: payload.phone,
                address_1: payload.address_1,
                address_2: payload.address_2,
                postcode: payload.postcode,
                city: payload.city,
                country_name: payload.country_name,
                country_code: payload.country_code,
                state: payload.state,
                registered: true,
                active: true,
                password: payload.password,
            }
        });

        if (apiResponse.res.data.response === 200) {
            yield put({
                type: ActionTypeConstants.SUBMIT_EDIT_USER_FORM_SUCCESS,
                payload
            });

            // yield put({ type: ActionTypeConstants.SUBMIT_USER_SETTINGS_FORM_SUCCESS });
            yield put(push('/'));
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Settings updated",
                    color: "success"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "An issue occurred",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }

    } catch (err) {
        console.log(err);
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "An issue occurred",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }

}

export default function*() {
    yield takeLatest(ActionTypeConstants.SUBMIT_USER_SETTINGS_FORM, submitUserSettingsFormSaga);
}
